import(/* webpackMode: "eager" */ "/app/apps/web/src/app/auth/forgot-password/page.tsx");
